import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import AccessModal from "components/AccessModal"

const TrendChartOrganism = ({ verdiktAlias, hasTrendsAccess }) => {
  const { pillarId: urlPillarId } = useParams()
  return (
    <div className="Verdikt-Score">
      <div
        className={classNames(urlPillarId, "page-frame", "AccessModalScope")}
      >
        <AccessModal
          open={!hasTrendsAccess}
          scoped
          translationKey="analyze:trendsAccessModal"
        />

        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule verdikt_alias={verdiktAlias} />
          </div>
        </div>
      </div>
    </div>
  )
}

TrendChartOrganism.propTypes = {
  verdiktAlias: PropTypes.string.isRequired,
  hasTrendsAccess: PropTypes.bool.isRequired,
}

export default TrendChartOrganism
